var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Print",staticStyle:{"background":"#fff","width":"100%","height":"100%"}},[_c('div',{attrs:{"id":"Print"}}),_c('el-button',{staticClass:"Btnprint",attrs:{"type":"default","size":"small"},on:{"click":_vm.print}},[_vm._v("打印")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }